<template>

  <div class="tg-wrapper" v-on:click="postponeIdleTimer()">

    <div class="home-overlay" v-show="showHome" v-on:click="hideHome()">
      <p>Les images que vous allez découvrir sont une petite partie de la sélection de près de 3’000 clichés opérée par Daniel Schelling, Laurence Vaucher et Pierre-André Delachaux entre 2010 et 2012.</p>
      <p>Le Conseil de Fondation tient à remercier vivement les deux anciens conservateurs du MRVT pour tout ce travail en amont qui a permis qu’aujourd’hui soit rendu dans ces murs un véritable hommage au photographe fleurisan.<p>
      <p><small>Cliquez et partagez avec ceux que vous aimez.</small></p>
    </div>  

    <div id="particles-js" class="confetti-overlay"></div>  

    <gallery-detail ref="galleryDetail"></gallery-detail>

    <div class="timeline-gallery">

      <scroll-sync proportional horizontal class="tg-gallery" ref="gallery">

        <div class="tg-gallery__pane" v-for="(imagesSrc, key) in imagesSrcLists" :key="imagesSrc.key" :class="[key % 2 ? 'is--depth-1' : 'is--depth-0']" :data-key="imagesSrc.key" ref="galleryItem">
          <span class="meta-year">{{ Math.abs(imagesSrc.key) }}</span>
          <div class="image-frame" v-for="image in imagesSrc.value" v-bind:key="image.id" v-on:click="showDetail(image.id)">
            <img v-bind:src="image.src" alt="">
          </div>

        </div>
      </scroll-sync>

      <div class="tg-timeline">
        <scroll-sync proportional horizontal class="tg-timeline__scroller" ref="timeline">
          <span class="meta-year" v-for="(imagesSrc, key) in imagesSrcLists" :key="imagesSrc.key" v-on:click="scrollToYear(imagesSrc.key)" v-bind:style="{ marginLeft: ((imagesSrc.value.length - 0.25) * 50) + 'px' }" ref="menuItem">
            {{Math.abs(imagesSrc.key)}}
          </span>
          <div class="scroll-offset">&nbsp;</div>
        </scroll-sync>
        <div class="tg-timeline__sep"></div>
        <img class="tg-timeline__loader" v-bind:style="{ transform: 'rotate(' + rotateLoader + 'rad)' }" src="../assets/confetti--2.svg" /> 
      </div>

    </div>

  </div>

</template>

<script>

import axios from 'axios';
import _ from 'lodash';
import Vue from 'vue';
import GalleryDetail from '../components/GalleryDetail.vue';
import 'particles.js';

import smoothscroll from 'smoothscroll-polyfill';
smoothscroll.polyfill();

import ScrollSync from 'vue-scroll-sync';
Vue.use(ScrollSync);

export default {
  name: 'TimelineGallery',
  props: {
    msg: String
  },
  components: {
    'scroll-sync': ScrollSync,
    'gallery-detail': GalleryDetail
  },
  data: function () {

    return {
      apiUrl: 'https://api.airtable.com/v0/appjR27yfG9sDMmMl/',
      apiKey: 'keyzAceNTyqQ2fjuY', // Always use a read-only account token
      base: 'borne_timeline',
      imagesSrcLists: null,
      imagesSrcListsRaw: [],
      panePositions: [],
      rotateLoader : 0,
      hasScrolled: null,
      showHome: true,
      lastScrollX: 0,
      speed: 0,
      idleTime: null,
    };

  },

  mounted: function () {
    this.getData();
  },

  methods: {

    getData: function (offset) {

      var self = this;

      var request = {
        url: this.apiUrl + this.base,
        headers: {
          'Authorization': `Bearer ${this.apiKey}`
        }
      };

      if (offset) {
        request.params = {
          'offset': offset
        }
      }

      axios(request).then((res) => {
        
        var records = res.data.records;

        var count = 0;
        records.forEach(function(item) {

          if (item.fields.year) {
            
            self.imagesSrcListsRaw.push( {
              id : item.fields.ref,
              src : 'img/photo/SCHELL-' + item.fields.ref + '.jpg',
              caption : item.fields.caption,
              year : item.fields.year,
              year_full : item.fields.year_full,
              location : item.fields.location
            } );
          }

          count++;
        }); 

        var offset = res.data.offset;

        if (offset) {

          self.getData(offset);

        } else {

          this.imagesSrcListsRaw = _.sortBy(this.imagesSrcListsRaw, function (x) {
            return parseInt(x.year);
          });

          var grouped = _.groupBy(this.imagesSrcListsRaw, function (x) {
            return parseInt(x.year);
          });

          this.imagesSrcLists = [];
          for (var key in grouped) {
              var value = grouped[key];
              this.imagesSrcLists.push({
                key: key,
                value: value
              })
          }

          this.imagesSrcLists = this.imagesSrcLists.reverse();

          this.init();

        }

      });
    },

    init: function () {

      var self = this;

      this.$nextTick(this.computePanePosition);
      this.$nextTick(this.handleScroll);
      
      window.setTimeout(function() {
        self.$refs.timeline.$el.scrollLeft = self.$refs.timeline.$el.scrollWidth;
      }, 500);

      document.querySelector('.tg-gallery').addEventListener('scroll', self.handleScroll);
      document.querySelector('.tg-gallery').addEventListener('scroll', self.setSpeed);
      document.querySelector('.tg-gallery').addEventListener('scroll', self.setLoaderRotation);

      window.particlesJS("particles-js", {
          "particles": {
              "number": {
                  "value": 6,
                  "density": {
                      "enable": true,
                      "value_area": 1500
                  }
              },
              "color": {
                  "value": ["#F0047F", "#FFFF00", "#33A44D", "#FF0000"]
              },
              "shape": {
                  "type": ["circle", "image"],
                  "image": {
                      "src": "/img/confetti--2.svg",
                      "width": 100,
                      "height": 100
                  }
              },
              "opacity": {
                  "value": 1,
                  "random": true,
                  "anim": {
                      "enable": false,
                      "speed": 1,
                      "opacity_min": 0.1,
                      "sync": false
                  }
              },
              "size": {
                  "value": 24,
                  //"random": true,
                  "anim": {
                      "enable": false,
                      "speed": 40,
                      "size_min": 0.1,
                      "sync": false
                  }
              },
              "line_linked": {
                  "enable": false,
                  "distance": 500,
                  "color": "#ffffff",
                  "opacity": 0.4,
                  "width": 2
              },
              "move": {
                  "enable": true,
                  "speed": 2,
                  "direction": "bottom",
                  "random": false,
                  "straight": false,
                  "out_mode": "out",
                  "bounce": false,
                  "attract": {
                      "enable": false,
                      "rotateX": 600,
                      "rotateY": 1200
                  }
              }
          },
          "retina_detect": true
      });

    },

    postponeIdleTimer: function () {
      
      var self = this;

      window.clearTimeout(this.idleTimer);
      this.idleTimer = _.delay(function() {

        if (!self.showHome) {
          self.showHome = true;
          self.$refs.timeline.$el.scrollLeft = self.$refs.timeline.$el.scrollWidth;
          self.$refs.galleryDetail.close();
        }

      }, 180000);
    },

    hideHome: function () {
      this.showHome = false;
    },
    
    computePanePosition: function () {

      var self = this;
      this.panePositions = [];

      _.each(this.$refs.galleryItem, function (pane, i) {
        self.panePositions.push( pane.getBoundingClientRect().left + ((i == 0)? 200 : 0) );
      });

      this.$refs.gallery.$el.classList.add('is--3d');

    },

    handleScroll: _.throttle ( function () {

      var self = this;
      var scrollX = this.$refs.gallery.$el.scrollLeft;
      var active = 0;
    
      var activePane = 0;
      if (scrollX > 0) {

        this.panePositions.forEach(function (panePos, i) {
          
          if (scrollX + (0.2 * 1920) > panePos) {
            activePane = i;
          }

        });
      }

      this.panePositions.forEach(function (panePos, i) {
        
        if (i == activePane) {
          self.$refs.menuItem[i].classList.add('is--active');
          self.$refs.galleryItem[i].classList.add('is--active');
        } else {
          self.$refs.menuItem[i].classList.remove('is--active');
          self.$refs.galleryItem[i].classList.remove('is--active');
        }

      });

    }, 200),

    setLoaderRotation: function () {

      var self = this;
      var scrollX = this.$refs.gallery.$el.scrollLeft;

      this.rotateLoader = scrollX / 200 % Math.PI;
    },

    setSpeed: function () {

      var self = this;

      window.clearTimeout( this.hasScrolled );
      
      this.hasScrolled = setTimeout(function() {
        pJSDom[0].pJS.particles.move.speed = 2;

        self.hasScrolledOnce = true;
        self.postponeIdleTimer();
      }, 66);

      var scrollX = self.$refs.gallery.$el.scrollLeft;
      var elapsed = 50;
      var delta = scrollX - self.lastScrollX;
      self.lastScrollX = scrollX;
  
      var v = 1000 * delta / (1 + elapsed);
      self.speed = 0.8 * v + 0.2 * self.speed;

      var asbSpeed = Math.abs(self.speed);
      if (asbSpeed > 2000) {
        window.pJSDom[0].pJS.particles.move.speed = 100;

      } else if (asbSpeed > 800) {
        window.pJSDom[0].pJS.particles.move.speed = 60;

      } else if (asbSpeed > 150) {
        window.pJSDom[0].pJS.particles.move.speed = 25;

      } else if (asbSpeed > 1) {
        window.pJSDom[0].pJS.particles.move.speed = 10;
      }

    },

    showDetail: function (id) {

      var image = _.find(this.imagesSrcListsRaw, {
        id: id
      });

      this.$refs.galleryDetail.setData(image);
    },

    scrollToYear: function (key) {

      var $pane = this.$el.querySelector(".tg-gallery__pane[data-key='" + key + "']");
      var offset = $pane.offsetLeft + $pane.offsetWidth - 0.8 * document.body.offsetWidth;
      var offset = this.$el.querySelector(".tg-gallery").scroll({
        top: 0, 
        left: offset,
        behavior: 'smooth' 
      });

    }

  }  
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">

  $mine-shaft-black: #232323;
  $tuatara-black: #323231;
  $pink: #fdc3c7;

  .home-overlay,
  .confetti-overlay {
    position: fixed;
    top: 0px;
    left: 0px;
    background: none;
    width: 100%;
    z-index: 99;
  }

  .home-overlay {
    box-sizing: border-box;
    height: calc(100vh - 212px);
    background: rgba(0,0,0,0.65);
    z-index: 99;
    text-align: center;
    font-size: 40px;
    padding: 10% 10% 0 10%;
    line-height: 1.4;
  }

  .confetti-overlay {
    height: 100%;
    background: none;
    pointer-events: none;
    z-index: 99;
  }
  
  .meta-year {
    font-size: 31px;
  }

  .timeline-gallery {
    text-align: center;
  }

  .tg-gallery {
    display: flex;
    flex-direction: row;
    overflow-x: scroll;
    overflow-y: hidden;
    -webkit-overflow-scrolling: touch;
    height: calc(100vh - 212px);
    perspective: 15em;
    perspective-origin: 50% 0%;

    &.is--3d .tg-gallery__pane.is--depth-1 {
      z-index: 0;
      transform: translateZ(0);
    }

    &.is--3d .tg-gallery__pane.is--depth-0 {
      z-index: 1;
      transform: translateZ(30px);
    }

    &::-webkit-scrollbar { 
      display: none;
      width: 0 !important; 
    }
  }

  .tg-gallery__pane {

    display: flex;
    flex-direction: row;
    padding: 0 75px;
    position: relative;

    &.is--depth-0 {
      padding-top: 120px;
      background: $mine-shaft-black;
      height: 640px;
    }

    &.is--depth-1 {
      padding-top: 140px;
      margin-bottom: 40px;
      background: $tuatara-black;

      .meta-year {
        top: 70px;
      }
    }

    &:first-child,
    &:last-child {
      width: 78vw!important;
      flex-shrink: 0;
      flex-direction: column;
    }

    &:first-child {
      align-items: flex-end;
    }

    &:last-child {
      align-items: flex-start;

      .meta-year {
        right: 150px;
      }
    }

    .meta-year {
      position: absolute;
      top: 50px;
      right: 75px;
      transition: opacity 0.2s, border-bottom-width 0.2s linear;
      border-bottom: 0px solid white;
    }

    &:not(.is--active) {
      .meta-year {
        opacity: 0.5;
      }
    }

    &.is--active {
      .meta-year {
        border-bottom-width: 2px;
      }
    }

    .image-frame {

      width: 25vw;
      max-height: 600px;

      &:not(:last-child) {
        margin-right: 115px;
      }

      img {
        display: block;
        //width: 100%;
        //height: auto;
        box-shadow: 1px 4px 7px 0px rgba(0, 0, 0, 0.77);

        max-width: 100%;
        max-height: 600px;
        width: auto;
        margin: auto;
      }
    } 
    
  }

  .tg-timeline {
    height: 212px;
    background: black;
    white-space: nowrap;
    position: relative;

    &:before,
    &:after {
      content: '';
      display: block;
      height: 95px;
      width: 40vw;
      position: absolute;
      top: 0;
      pointer-events: none;
    }

    &:before {
      left: 0;
      background: linear-gradient(to right, rgba(0,0,0,0.65) 0%,rgba(0,0,0,0) 100%);
    }

    &:after {
      right: 0;
      background: linear-gradient(to left, rgba(0,0,0,0.65) 0%,rgba(0,0,0,0) 100%);
    }

    .tg-timeline__scroller {
      height: 95px;
      margin: auto;
      overflow-x: scroll;
      display: flex;
      vertical-align: bottom;
      align-items: flex-end;
      margin-bottom: 11px;

      .meta-year {
        
        &:first-child {
          margin-left: 50vw!important;
        }

      }

      .scroll-offset {
        display: block;
        margin-left: calc(50vw - 70px)!important;
      }
      
      &::-webkit-scrollbar { 
        display: none;
        width: 0 !important; 
      }
    }

    .tg-timeline__sep {
      height: 11px;
      width: 100%;
      background-image: url('../assets/timeline-gradient.png');
      margin-bottom: 21px;
    }

    .tg-timeline__loader {
      height: 2.25rem;
      width: 2.25rem;
    }

    .meta-year {
      transition: font-size 0.2s; 

      &.is--active {
        font-weight: bold;
        font-size: 59px;
      }
    }
  }

</style>
